import { useMutation } from 'react-query';

import { useVpSnackbar } from '../vp-ui';
import api from '../utils/api';
import { DOWNLOAD } from '../constants/endpoints';

const postDownloadData = ({ data }) => api.post(DOWNLOAD, data);
export const usePostDownloadData = () => {
  const { addSnackbarError, addSnackbarSuccess } = useVpSnackbar();

  return useMutation(postDownloadData, {
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || '';

      addSnackbarError({
        message: `Error attempting to download selected videos. ${errorMessage}`
      });
    },
    onSuccess: () => {
      addSnackbarSuccess({
        message: `Your download is In Progress! We'll email you as soon as it's done!`
      });
    }
  });
};

const createDownloadPresignedUrl = (payload) => api.post(`${DOWNLOAD}/presigned`, payload);
export const useCreateDownloadPresignedUrl = () => {
  const { addSnackbarError } = useVpSnackbar();

  return useMutation(createDownloadPresignedUrl, {
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || '';
      console.error('Download Error: ', errorMessage);

      addSnackbarError({
        message: `Error attempting to download file: ${errorMessage}`
      });
    },
  });
};



// WEBPACK FOOTER //
// ./src/hooks/useDownloadData.js